import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import WhyChooseSection from './components/WhyChooseSection';
import HowItWorksSection from './components/HowItWorksSection';
import SafetySection from './components/SafetySection';
import ArticleCtaSection from './components/ArticleCtaSection';
import ArticleCardGrid from './components/ArticleCardGrid';

export default function Home() {
  const siteUrl = 'https://kakobuypolska.cfd';

  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <WhatIsSection />
          <CategoryGrid />
          <WhyChooseSection />
          <HowItWorksSection />
          <ArticleCardGrid />
          <SafetySection />
          <ArticleCtaSection />
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Kakobuy Spreadsheet Polska',
            url: siteUrl,
            description: 'Najlepsza baza produktów i linków zakupowych Kakobuy Spreadsheet dla polskich klientów. Aktualne listy, kategorie i przewodniki.',
            inLanguage: 'pl-PL',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Kakobuy Spreadsheet Polska',
            url: siteUrl,
            description: 'Najlepsza baza produktów i linków zakupowych Kakobuy Spreadsheet dla polskich klientów.',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />
    </>
  );
}